// extracted by mini-css-extract-plugin
export default {"input":"color-input_input__C-MY-"};